import * as React from "react";
import { withTheme, WithTheme } from "@material-ui/core";

interface CaretProps {
    align?: "left" | "right";
    color: string;
    opacity?: number;
    variant?: "normal" | "thick";
    top?: number;
    bottom?: number;
}

class Caret extends React.Component<CaretProps & WithTheme> {

    public render() {

        const { color, opacity, theme, variant, top, bottom } = this.props;

        return (
            // tslint:disable-next-line:jsx-alignment
            <div style={{
                marginTop: theme.spacing.unit * (top ? top : 4),
                marginBottom: theme.spacing.unit * (bottom ? bottom : 5),
                height: variant && variant === "thick" ? 4 : 2,
                width: 32,
                opacity: opacity ? opacity : 1,
                backgroundColor: color
                }}
            />
        );
    }

}

export default withTheme()(Caret);


// WEBPACK FOOTER //
// ./src/components/Caret/Caret.tsx